import * as React from 'react';
import { SecuredUserManagementClient } from 'Core/Api/UserManagement/SecuredUserManagementClient';
import Utility from 'Core/Utility';
import { ErrorResultModel, ResetPasswordModel } from 'Core/Api/UserManagement/Api';


export interface Props {
  children?: React.ReactNode;
}

export interface State {
  EmailAddress: string;
  CurrentPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}


class ForgetPasswordCompleteFormHandler extends React.Component<Props, State> {

  ResetPassword(resetPassword: ResetPasswordModel) {
    let client = new SecuredUserManagementClient();
    client.showLoading = true;
    return client.authentication_ResetPassword(resetPassword)
      .catch(Utility.formatError);
  }

}

export default ForgetPasswordCompleteFormHandler;



